import { apiService } from '../services/api';
import { getValidToken, isDemoToken } from './tokenUtils';
import { clearUserFromLocalStorage } from './userUtils';

class TokenManager {
  constructor() {
    this.refreshTimer = null;
    this.refreshInterval = 6 * 24 * 60 * 60 * 1000; // 6 дней в миллисекундах
    this.isRefreshing = false;
  }

  // Инициализация автоматического обновления токена
  init() {
    const token = getValidToken();
    
    // Если это демо токен, НЕ удаляем его - он поддерживается бэкендом
    if (isDemoToken(token)) {
      // Для demo токена не запускаем автообновление
      return;
    }

    if (token) {
      this.startAutoRefresh();
    }
  }

  // Запуск автоматического обновления
  startAutoRefresh() {
    this.clearAutoRefresh();
    
    this.refreshTimer = setInterval(async () => {
      await this.refreshToken();
    }, this.refreshInterval);
  }

  // Остановка автоматического обновления
  clearAutoRefresh() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  }

  // Обновление токена
  async refreshToken() {
    if (this.isRefreshing) {
      return;
    }

    const token = getValidToken();
    
    if (!token) {
      return;
    }
    
    // Для demo токена не пытаемся обновить
    if (isDemoToken(token)) {
      return;
    }

    try {
      this.isRefreshing = true;
      
      const response = await apiService.refreshToken();
      const newToken = response.data.access_token;
      
      // Сохраняем новый токен
      localStorage.setItem('token', newToken);
      
      // Обновляем информацию о пользователе
      const userData = localStorage.getItem('user');
      if (userData) {
        const user = JSON.parse(userData);
        user.token = newToken;
        user.expires_in = response.data.expires_in;
        localStorage.setItem('user', JSON.stringify(user));
      }
      
    } catch (error) {
      // Если обновление не удалось, очищаем данные и перенаправляем на вход
      this.logout();
    } finally {
      this.isRefreshing = false;
    }
  }

  // Выход из системы
  logout() {
    this.clearAutoRefresh();
    localStorage.removeItem('token');
    clearUserFromLocalStorage();
    localStorage.setItem('skip_demo_login', 'true');
    window.location.href = '/login';
  }

  // Проверка, нужно ли обновить токен
  shouldRefreshToken() {
    const token = getValidToken();
    
    if (!token) {
      return false;
    }

    // Для demo токена никогда не обновляем
    if (isDemoToken(token)) {
      return false;
    }
    
    const userData = localStorage.getItem('user');
    if (!userData) {
      return false;
    }

    try {
      const user = JSON.parse(userData);
      const expiresIn = user.expires_in;
      
      if (!expiresIn) {
        return false;
      }

      // Обновляем токен за 1 день до истечения
      const oneDayInSeconds = 24 * 60 * 60;
      return expiresIn < oneDayInSeconds;
    } catch (error) {
      return false;
    }
  }

  // Проверка активности пользователя
  checkUserActivity() {
    // Обновляем токен при активности пользователя, если он скоро истечет
    if (this.shouldRefreshToken()) {
      this.refreshToken();
    }
  }
}

// Создаем единственный экземпляр
const tokenManager = new TokenManager();

// Добавляем обработчики активности пользователя
document.addEventListener('click', () => tokenManager.checkUserActivity());
document.addEventListener('keydown', () => tokenManager.checkUserActivity());
document.addEventListener('scroll', () => tokenManager.checkUserActivity());

export default tokenManager;
